import { createRoot } from "react-dom/client";
import "./index.css";

const root = createRoot(document.getElementById("root")!);

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

if (!supabaseUrl || !supabaseKey) {
  root.render(
    <div style={{ fontFamily: 'system-ui, sans-serif', maxWidth: 600, margin: '80px auto', padding: '0 24px' }}>
      <h1 style={{ fontSize: 24, marginBottom: 16 }}>Configuration Error</h1>
      <p style={{ color: '#666', lineHeight: 1.6 }}>
        The application is missing required environment variables. Please ensure
        <code style={{ background: '#f3f4f6', padding: '2px 6px', borderRadius: 4 }}> VITE_SUPABASE_URL </code> and
        <code style={{ background: '#f3f4f6', padding: '2px 6px', borderRadius: 4 }}> VITE_SUPABASE_PUBLISHABLE_KEY </code>
        are set in your deployment environment and redeploy.
      </p>
    </div>
  );
} else {
  import("./App.tsx")
    .then(({ default: App }) => {
      return import("@/components/ErrorBoundary").then(
        ({ default: ErrorBoundary }) => {
          root.render(
            <ErrorBoundary>
              <App />
            </ErrorBoundary>,
          );
        },
      );
    })
    .catch((error) => {
      console.error("Failed to load application modules:", error);
      root.render(
        <div
          style={{
            fontFamily: "system-ui, sans-serif",
            maxWidth: 600,
            margin: "80px auto",
            padding: "0 24px",
          }}
        >
          <h1 style={{ fontSize: 24, marginBottom: 16 }}>Application Error</h1>
          <p style={{ color: "#666", lineHeight: 1.6 }}>
            The application failed to load required modules. Please try refreshing
            the page. If the problem persists, contact support.
          </p>
        </div>,
      );
    });
}
